export default {"src":"/_next/static/media/calendar-month.1e36dcf8.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};